import {Component, OnChanges, OnInit, SimpleChanges, input} from '@angular/core';

@Component({
    selector: 'app-pie-legend',
    templateUrl: './pie-legend.component.html',
    styleUrls: ['./pie-legend.component.scss'],
    standalone: false
})
export class PieLegendComponent implements OnInit, OnChanges {

  readonly data = input<any>();

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
